import { Button, Container, Grid, Paper, TextField, styled, Tooltip, Typography, InputAdornment, IconButton, useTheme, ListItem, ListItemButton, ListItemIcon, Box, List, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import ChatIcon from '@mui/icons-material/Chat';
import { useNavigate } from "react-router-dom";
import chat from "../../assets/img/chat.svg";
import config from "../../assets/img/config.svg";
import usuario from "../../assets/img/cuenta.svg";
import cartera from "../../assets/img/billetera.svg";
import vestidor from "../../assets/img/vestidor.svg";
import cuentas from "../../assets/img/cuentas_usuario.svg";
import docs from "../../assets/img/docs.svg";
import tienda from "../../assets/img/tienda.svg";
import berhu from "../../assets/img/Berhu.png";
import SendIcon from '@mui/icons-material/Send';
import buscar from "../../assets/img/buscar.svg";
import image from "../../assets/images";
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import { motion, AnimatePresence } from 'framer-motion';
import BerIuModal from './BerIuModal';


import {
  Camera as CameraIcon,
  Checkroom as ShirtIcon,
  ExitToApp as LogoutIcon,
  Language as LanguageIcon
} from '@mui/icons-material';
import { SideMenuToggle } from "./sideBar";



export const DashboardPage: React.FC<{}> = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const nav = useNavigate();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false)

  // useEffect(() => {
  //   const token = localStorage.getItem("userId");
  //   if (!token) {
  //     // No hay sesión activa, redirigir al login
  //     nav("/");
  //   }
  // }, [nav]);

  const menuItems = [
    { icon: image.settings, fallbackIcon: <SettingsIcon />, label: 'Settings', url: '/settings' },
    { icon: image.user, fallbackIcon: <PersonIcon />, label: 'Profile', url: '/profile' },
    { icon: image.camara, fallbackIcon: <CameraIcon />, label: 'Camera', url: '/camera' },
    { icon: image.shop, fallbackIcon: <CameraIcon />, label: 'Shop', url: '/shop' },
    { icon: image.key, fallbackIcon: <CameraIcon />, label: 'Key', url: '/key' },
    { icon: image.shirt, fallbackIcon: <ShirtIcon />, label: 'Clothing', url: '/clothing' },
    { icon: image.chat, fallbackIcon: <ChatIcon />, label: 'Chat', url: '/chat' },
    { icon: image.catalogo, fallbackIcon: <SearchIcon />, label: 'Search', url: '/search' },
  ];


  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen)
  }



  const ZoomIconWrapper = styled(Grid)(({ theme }) => ({
    transition: theme.transitions.create(['transform', 'box-shadow'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      transform: 'scale(1.2)',
      boxShadow: theme.shadows[4],
    },
  }));
  const menuVariants = {
    open: { x: 0, opacity: 1 },
    closed: { x: "-100%", opacity: 0 }
  }
  const fabVariants = {
    initial: { x: 0 },
    activated: { x: 100 },
  };

  return (
    <Container maxWidth="xl" sx={{
      // overflow: 'visible',
      // width:  '100em',
      height: '100%',
      display: 'flex',
      position: 'relative',
    }}>
      <Grid
        container
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        sx={{
          minHeight: "100vh"
        }}>
        <Paper sx={{
          mt: isMobile ? 0.5 : 3,
          mb: isMobile ? 0.5 : 3,
          padding: "1.2em",
          borderRadius: "3em",
          background: "white",
          height: isMobile ? "93vh" : "700px",
          width: isMobile ? "100%" : "70em",
          alignContent: "center",
          position: "static",
        }}>
          <motion.div
            initial="closed"
            animate={isSideMenuOpen ? "open" : "closed"}
            variants={menuVariants}
            transition={{ type: "spring", stiffness: 100, damping: 20 }}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: '100px',
              backgroundColor: '#f0f0f0',
              zIndex: 10,
              padding: '20px',
              borderRadius: 10,
              boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
            }}
          >
            <Box sx={{ overflow: 'auto', height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ p: 1, mb: 2 }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '12px',
                    bgcolor: 'white',
                    display: 'flex',
                    // alignItems: 'center',
                    // justifyContent: 'center',
                    fontWeight: 'bold',
                    color: 'text.primary',
                  }}
                >
                  <img src={image.berusLogo} alt="Berus Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </Box>
                <ZoomIconWrapper>
                  <ListItemButton
                    onClick={() => navigate("/dash")}
                    sx={{
                      minHeight: 48,
                      justifyContent: 'center',
                      px: 2.5,
                      borderRadius: '50%',
                    }}
                  >

                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        justifyContent: 'center',
                      }}
                    >
                      <HomeIcon />
                    </ListItemIcon>
                  </ListItemButton>
                </ZoomIconWrapper>
              </Box>
              <List>
                {menuItems.map((item, index) => (
                  <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                    <ZoomIconWrapper>
                      <ListItemButton
                        onClick={() => navigate(item.url)}
                        sx={{
                          top: 0,
                          minHeight: 60,
                          justifyContent: 'center',
                          px: 2.5,
                          alignItems: 'center',
                          height: '100%',
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: 'auto',
                            justifyContent: 'center',
                          }}
                        >
                          {item.icon ? (
                            <img src={item.icon} alt={item.label} style={{ width: 24, height: 24 }} />
                          ) : (
                            item.fallbackIcon
                          )}
                        </ListItemIcon>
                      </ListItemButton>
                    </ZoomIconWrapper>
                  </ListItem>
                ))}
              </List>
              <Box sx={{ mt: 'auto' }}>
                <List>
                  {[{ icon: <LanguageIcon />, label: 'Language' }, { icon: <LogoutIcon onClick={() => nav('/')} />, label: 'Logout' }].map((item, index) => (
                    <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                      <ZoomIconWrapper>
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: 'center',
                            px: 2.5,
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: 'auto',
                              justifyContent: 'center',
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                        </ListItemButton>
                      </ZoomIconWrapper>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </motion.div>
          <Button
            variant="contained"
            onClick={handleOpenModal}
            sx={{
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            Tutorial
          </Button>
          <BerIuModal open={isModalOpen} onClose={handleCloseModal} />
          <img src={berhu} alt="Berhu logo"
            style={{
              marginTop: "5px",
              marginLeft: isMobile ? '' : "15em",
              marginBottom: "50px",
            }} />
          <Typography
            style={{
              marginTop: "2px",
              marginLeft: isMobile ? '100px' : "17em",
              marginBottom: isMobile ? '' : "20px",
              fontSize: "30px",
            }}
          >Menú</Typography>
          <TextField
            variant="outlined"
            size="small"
            sx={{
              ml: isMobile ? '' : "25em",
              width: isMobile ? '340px' : "25em",
              marginLeft: isMobile ? '' : "350px"
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title="Enviar">
                    <IconButton sx={{
                      background: "#FEE483", ":hover": {
                        background: "pink"
                      }
                    }}>
                      {/* <SendIcon /> */}
                      <img src={buscar} alt="Enviar" />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          ></TextField>
          <div className="mx-auto place-self-center">
            <div className={isMobile ? 'grid container grid-cols-2 place-items-center mt-5 gap-x-1 gap-y-0.5' : "grid container grid-cols-4 place-items-center mt-10"}>
              <motion.div
                initial="initial"
                animate={isSideMenuOpen ? "activated" : "initial"}
                variants={fabVariants}
                transition={{ type: "tween", duration: 0.5 }}
                style={{
                  position: 'absolute',
                  left: -0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                }}
              >
                <SideMenuToggle isSideMenuOpen={isSideMenuOpen} toggleSideMenu={toggleSideMenu} />
              </motion.div>
              <div className="card">
                <Tooltip title="Chat">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    onClick={() => nav("/chat")}
                    sx={{
                      borderRadius: "20%"
                    }}>
                    {/*<ChatIcon
                      fontSize="large"
                      sx={{
                        color:"white"
                      }}
                    />*/}
                    <img src={chat} alt="Chat"></img>
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    // marginLeft: "40px",
                    fontSize: "20px",
                    fontWeight: "bold"
                  }}
                >Chat</h3>
              </div>
              <div className="card">
                <Tooltip title="Configuración">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    sx={{
                      borderRadius: "20%"
                    }}
                  >
                    {/* <SettingsIcon fontSize="large" /> */}
                    <img src={config} alt="Configuración" />
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold"
                  }}
                >Configuración</h3>
              </div>
              <div className="card">
                <Tooltip title="Cuenta">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    sx={{
                      borderRadius: "20%"
                    }}
                  >
                    {/* <PersonIcon fontSize="large" /> */}
                    <img src={usuario} alt="Usuario" />
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    marginTop: "5px",
                    marginLeft: "18px",
                    fontSize: "20px",
                    fontWeight: "bold"
                  }}
                >Usuario</h3>
              </div>
              <div className="card">
                <Tooltip title="Cartera">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    sx={{
                      borderRadius: "20%"
                    }}
                  >
                    {/* <WalletIcon fontSize="large" /> */}
                    <img src={cartera} alt="Cartera" />
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    marginTop: "5px",
                    marginLeft: "20px",
                    fontSize: "20px",
                    fontWeight: "bold"
                  }}
                >Cartera</h3>
              </div>
              <div className="card">
                <Tooltip title="Tienda">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    sx={{
                      borderRadius: "20%"
                    }}>
                    {/* <StoreIcon fontSize="large" /> */}
                    <img src={tienda} alt="Tienda" />
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    marginTop: "5px",
                    marginLeft: "20px",
                    fontSize: "20px",
                    fontWeight: "bold"
                  }}
                >Tienda</h3>
              </div>
              <div className="card">
                <Tooltip title="Documentos">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    sx={{
                      borderRadius: "20%"
                    }}
                  >
                    {/* <FolderSharedIcon fontSize="large" /> */}
                    <img src={docs} alt="Documentos" />
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    marginTop: "5px",
                    marginLeft: "20px",
                    fontSize: "20px",
                    fontWeight: "bold"
                  }}
                >Documentos</h3>
              </div>
              <div className="card">
                <Tooltip title="Vestidor">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    sx={{
                      borderRadius: "20%"
                    }}
                  >
                    {/* <CheckroomIcon fontSize="large" /> */}
                    <img src={vestidor} alt="Vestidor" />
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    marginTop: "5px",
                    marginLeft: "20px",
                    fontSize: "20px",
                    fontWeight: "bold"
                  }}
                >Vestidor</h3>
              </div>
              <div className="card">
                <Tooltip title="Cuentas de Usuario">
                  <Button
                    variant="contained"
                    className={isMobile ? "size-20" : "size-30"}
                    sx={{
                      borderRadius: "20%"
                    }}
                  >
                    <img src={cuentas} alt="Cuentas de Usuario" />
                  </Button>
                </Tooltip>
                <h3
                  style={{
                    marginTop: "5px",
                    marginLeft: "20px",
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginBottom: "-50px",
                    alignContent: "center"
                  }}
                >Cuentas de <br />Usuario</h3>

              </div>
            </div>
          </div>
        </Paper>
      </Grid>
    </Container >
  );
};
